import { createSelector } from 'reselect';
import { getCoreState } from './core-state';
import { ChildReducerName } from '../constants/other';
export const getToastsState = (state) => getCoreState(state)[ChildReducerName.toasts];
export const getToastsItems = (state) => getToastsState(state).items;
export const getToastsIds = (state) => getToastsState(state).ids;
export const getToasts = createSelector(getToastsItems, getToastsIds, (items, ids) => ids.map((id) => items[id]));
